module.exports = __webpack_public_path__ + "static/media/comment-alt-verify.b5937abf.svg";